import { create } from "zustand";
import { QueuesWithResourcesActions, QueuesWithResourcesState } from "./types";
import { QueueWithResources } from "@/repository/models";

export const useQueuesWithResourcesStore = create<
	QueuesWithResourcesState & QueuesWithResourcesActions
>((set, get) => ({
	queues: [],
	setQueues: (queues: QueueWithResources[]) => set({ queues: queues }),
	getQueueById: (id: string | undefined) =>
		get().queues.find((q) => q.id === id),
}));
